export default __webpack_public_path__ + "static/media/officialTW.04b42a29.jpg";